/*
  "Send as a gift link" in the tote (snippets/mm-cart-gift-link.liquid).

  The tick is saved on the cart as the attribute "Gift link" = "Yes", which shows on the
  order under Additional details and is what the Netlify function hook-gift.mjs looks
  for. Unticking clears it. Nothing is re-rendered by a save; when Shopify re-renders the
  tote for some other reason, Liquid rebuilds the tick from cart.attributes and this
  element simply connects again.

  The gift panel around it (mm-cart-gift) stops "change" events at its own edge, because
  Dawn's cart-drawer-items treats every change inside the drawer as a quantity change.
  So the listener sits on the tick box itself, not on document.

  Cleared automatically when:
    the shopper switches "Is this a gift?" off (event mm:gift:change with on = false)
    a gift card is in the tote (the snippet renders a hidden element with data-blocked)

  Cash on delivery (30 Sep 2026): when the theme setting "Gift link line" is set, the same call also adds or takes
  out that free product (data-variant-id), and the tote is repainted, because a payment rules app hides cash on
  delivery while that line is in the tote. Liquid tells this script when the tote is out of step (data-fix):
  add (ticked, no line, or more than one), remove (line but not ticked), clear (the line with nothing else).

  Customer event for the custom pixel: gift_link_option { on, context }.

  Words: read from the <script data-mm-i18n> block inside this element (locale keys
  under mm.gift_link) each time a message is written; English below is the fallback.
*/
(function () {
  if (customElements.get('mm-cart-gift-link')) return;

  var KEY = 'Gift link';
  var inflight = null;

  var FALLBACK = {
    saved: 'Gift link on. Pay online, and your link arrives by WhatsApp and email.',
    failed: 'We couldn\'t save that. Check your connection and try again.',
    checkout_on: 'Check out with your details',
    checkout_off: 'Check out'
  };

  function t(scope, key) {
    var words = {};
    var block = scope && scope.querySelector('[data-mm-i18n]');
    if (block) { try { words = JSON.parse(block.textContent) || {}; } catch (e) { words = {}; } }
    var text = words[key];
    if (typeof text !== 'string' || !text || text.indexOf('translation missing') !== -1) text = FALLBACK[key];
    if (text.indexOf('&') !== -1) {
      var box = document.createElement('textarea');
      box.innerHTML = text;
      text = box.value;
    }
    return text;
  }

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* Same sections and repaint as assets/mm-cart-gift.js, so the tote looks the same whoever changed it. */
  function sectionsToRender() {
    var list = [];
    if (document.getElementById('CartDrawer')) list.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) list.push('cart-icon-bubble');
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) list.push(items.dataset.id);
    if (footer && footer.dataset.id) list.push(footer.dataset.id);
    return list;
  }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function paint(sections) {
    if (!sections) return;
    var drawerEl = document.getElementById('CartDrawer');
    if (drawerEl && sections['cart-drawer']) {
      var fresh = parse(sections['cart-drawer']).getElementById('CartDrawer');
      if (fresh) {
        drawerEl.innerHTML = fresh.innerHTML;
        var drawer = document.querySelector('cart-drawer');
        var overlay = drawerEl.querySelector('#CartDrawer-Overlay');
        if (drawer && overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var freshBubble = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
    }
    ['main-cart-items', 'main-cart-footer'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el || !el.dataset.id || !sections[el.dataset.id]) return;
      var target = el.querySelector('.js-contents');
      var source = parse(sections[el.dataset.id]).querySelector('.js-contents');
      if (target && source) target.innerHTML = source.innerHTML;
    });
  }

  /*
    One save at a time; a second change waits for the first so the last answer wins.
    on: the tick. variantId: the free gift link line, or '' to save the tick only.
    Returns the cart JSON; its sections are painted when the line changed.
  */
  function save(on, variantId) {
    var body = { attributes: {} };
    body.attributes[KEY] = on ? 'Yes' : '';
    if (variantId) {
      body.updates = {};
      body.updates[variantId] = on ? 1 : 0;
      body.sections = sectionsToRender();
      body.sections_url = window.location.pathname;
    }
    var send = function () {
      return fetch(root() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart update failed');
        return r.json();
      }).then(function (json) {
        if (variantId) paint(json.sections);
        return json;
      });
    };
    inflight = (inflight || Promise.resolve()).catch(function () {}).then(send);
    return inflight;
  }

  function track(on, context) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('gift_link_option', { on: on, context: context });
      }
    } catch (e) { /* ignore */ }
  }

  function allTicks() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-mm-gift-link-tick]'));
  }

  class MmCartGiftLink extends HTMLElement {
    connectedCallback() {
      /* Gift card in the tote with the attribute still set: clear it quietly. */
      if (this.dataset.blocked === 'true') {
        save(false, this.dataset.variantId || '').catch(function () {});
        return;
      }
      /* The tote is out of step with the tick: put it right once. */
      var fix = this.dataset.fix;
      if (fix && !this.fixing) {
        this.fixing = true;
        save(fix === 'add', this.dataset.variantId || '').catch(function () {});
      }
      this.tick = this.querySelector('[data-mm-gift-link-tick]');
      this.status = this.querySelector('[data-mm-gift-link-status]');
      if (!this.tick || this.bound) return;
      this.bound = true;
      this.tick.addEventListener('change', this.onChange.bind(this));
    }

    say(text, tone) {
      if (!this.status) return;
      this.status.textContent = text || '';
      if (tone) this.status.setAttribute('data-tone', tone); else this.status.removeAttribute('data-tone');
    }

    onChange(event) {
      event.stopPropagation();
      var self = this;
      var on = this.tick.checked;
      this.tick.disabled = true;
      this.say('');
      var context = this.dataset.context || 'drawer';
      save(on, this.dataset.variantId || '').then(function () {
        /* The drawer and the cart page can both be on screen, and a repaint makes new ones: keep them the same. */
        allTicks().forEach(function (t) { t.checked = on; });
        /* The "your link arrives" line is part of the markup, shown while the gift link is on; keep it in step here
           too, for the case where nothing was repainted (no gift link line set in theme settings). */
        document.querySelectorAll('[data-mm-gift-link-on]').forEach(function (line) { line.hidden = !on; });
        checkoutLabels(on);
        document.querySelectorAll('mm-cart-gift-link').forEach(function (el) {
          if (typeof el.say === 'function') el.say('');
        });
        track(on, context);
      }).catch(function () {
        self.tick.checked = !on;
        self.say(t(self, 'failed'), 'error');
      }).then(function () {
        self.tick.disabled = false;
      });
    }
  }

  /* The checkout buttons say whose details checkout wants while the gift link is on. The tote page's button sits
     outside the part that repaints, so it is set here as well as in the markup. */
  function checkoutLabels(on) {
    var holder = document.querySelector('mm-cart-gift-link.mm-gift-link') || document.querySelector('mm-cart-gift-link');
    var text = t(holder, on ? 'checkout_on' : 'checkout_off');
    if (!text) return;
    ['checkout', 'CartDrawer-Checkout'].forEach(function (id) { var b = document.getElementById(id); if (b) b.textContent = text; });
  }

  customElements.define('mm-cart-gift-link', MmCartGiftLink);

  /* "Is this a gift?" switched off: a gift link without a gift makes no sense, so clear it. */
  document.addEventListener('mm:gift:change', function (event) {
    if (!event.detail || event.detail.on !== false) return;
    var ticked = allTicks().some(function (t) { return t.checked; });
    if (!ticked) return;
    var holder = document.querySelector('mm-cart-gift-link[data-variant-id]');
    save(false, holder ? holder.dataset.variantId || '' : '').then(function () {
      allTicks().forEach(function (t) { t.checked = false; });
      checkoutLabels(false);
    }).catch(function () {});
  });
})();
